import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoAlphaSeeker, selectAlgoErrors } from '@/store/orders/algoOrders/selectors.ts';

export const AlgoAlphaSeeker = () => {
  const tileId = useAlgoTileId();
  const track = useTrackEvent();

  const value = useAppSelector((state) => selectAlgoAlphaSeeker(state, tileId));
  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));

  const validateAlgo = useValidateAlgo();

  const handleAlphaSeekerChange = (newValue: boolean) => {
    track('Order action', 'Alpha seeker changed');
    validateAlgo({
      alphaSeeker: newValue,
    });
  };

  const alphaSeekerError = errors?.alphaSeeker;

  return (
    <OrderRow labelId="order.fields.alphaSeeker">
      <OmsFieldErrorWrapper errors={alphaSeekerError}>
        <div className="form-check form-check-sm">
          <input
            id="alphaSeeker"
            className="form-check-input me-8px"
            type="checkbox"
            checked={value}
            onChange={(e) => handleAlphaSeekerChange(e.target.checked)}
            data-e2e={'alphaSeeker-checkbox'}
          />
        </div>
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
